"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCategoriesExtraReducers = void 0;
const tslib_1 = require("tslib");
const services_1 = tslib_1.__importDefault(require("../../../services"));
const toolkitRaw = tslib_1.__importStar(require("@reduxjs/toolkit"));
const helpers_1 = require("./helpers");
const getCategories = toolkitRaw.createAsyncThunk('market/getCategories', async (data, { rejectWithValue }) => {
    var _a, _b;
    try {
        const response = await services_1.default.get('/api/item_categories', {
            headers: {
                'Content-Type': 'application/json',
                'Accept-Language': ((_b = (_a = data === null || data === void 0 ? void 0 : data.setting) === null || _a === void 0 ? void 0 : _a.headers) === null || _b === void 0 ? void 0 : _b.lang) || 'pt',
            },
        });
        const categories = response.data;
        const mainCategories = (0, helpers_1.selectMainCategories)(categories);
        return { categories: categories.data, mainCategories };
    }
    catch (eventError) {
        return rejectWithValue(eventError);
    }
});
const getCategoriesExtraReducers = (builder) => {
    builder.addCase(getCategories.pending, (state) => {
        state.categories.loading = true;
    });
    builder.addCase(getCategories.fulfilled, (state, action) => {
        state.categories.loading = false;
        state.categories.error = false;
        state.categories.data = action.payload.categories;
        state.categories.mainCategories = action.payload.mainCategories;
    });
    builder.addCase(getCategories.rejected, (state) => {
        state.categories.loading = false;
        state.categories.error = true;
    });
};
exports.getCategoriesExtraReducers = getCategoriesExtraReducers;
exports.default = getCategories;
//# sourceMappingURL=index.js.map